import { createSelector } from '@ngrx/store';

import { selectBrandsState } from '../../reducers';
import { BrandsState } from './brands.reducer';

/**
 * Get Brands
 */
export const brands = createSelector(
  selectBrandsState,
  (state: BrandsState) => state
);

/**
 * Get Brand
 */
export const brand = createSelector(
  selectBrandsState,
  (state: BrandsState) => state.brand
);

/**
 * Get Brand list
 */
export const brandsList = createSelector(
  selectBrandsState,
  (state: BrandsState) => state.brands
);

/**
 * Get Brand list
 */
export const brandsListLoader = createSelector(
  selectBrandsState,
  (state: BrandsState) => state.isLoadingBrand
);

/**
 * Get Brand id
 */
export const brandUuid = createSelector(
  selectBrandsState,
  (state: BrandsState) => state.brandUuid
);

/**
 * Get Brand names by ids
 */
export const brandNames = createSelector(
  selectBrandsState,
  (state: BrandsState) => {
    return {
      brandDisplayNames: state.brandDisplayNames,
      invalidBrandIds: state.invalidBrandIds,
    };
  }
);

/**
 * Get Brand by ids
 */
export const brandIds = createSelector(
  selectBrandsState,
  (state: BrandsState) => state.brandIds
);
